<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { RICH_TOOLTIP_CLASS } from "../../../../../../../../../_shared/_logic/rich-tooltips"
  import type { WorkOrderRow } from "../../../../_logic/work-order-table-model"

  type Props = {
    row: WorkOrderRow
  }

  const { row }: Props = $props()
</script>

<span class="action-required-cell">
  <StatusTag
    size="sm"
    status={row.actionRequiredStatusDefinition}
    subLabel={row.actionRequiredSubLabel}
    tooltipContent={row.actionRequiredStatusTooltip}
    tooltipHtml={true}
    tooltipClassName={RICH_TOOLTIP_CLASS}
    disableTitle={true}
  />
</span>

<style lang="less">
  .action-required-cell {
    display: inline-flex;
    align-items: flex-start;
    max-width: 100%;
  }
</style>
